// src/App.js
// ... (other imports)
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';

import Home from './pages/home';
import About from './pages/about';
import Contact from './pages/contact';
// import BakeryFooter from './components/footer';
import Services from './pages/services';
import AdminLayout from './AdminLayout';
import Cart from './pages/cart';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Register from './pages/Register';
import Checkout from './pages/Checkout';
import Cakes from './pages/Cakes';
import Product from './pages/Product';
import PrivateRoutes from './PrivateRoute';
import Notfound from './pages/Notfound';
import Adminlogin from './admin/index';
import Filter from './pages/Filter';




function App() {
  return (

    
    <Router>
      
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Services />} />
          <Route path="/cake" element={<Cakes />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/product/:id" element={<Product />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/gallery" element={<Filter />} />
          {/* <Route path="/admin/index" element={<Login />} /> */}
          <Route path="/404" element={<Notfound />} />
          <Route path="/admin" element={<Adminlogin />} />

          {/* Admin Dashboard Here */}
          <Route
    path="/admin/*"
    element={<PrivateRoutes element={AdminLayout} />}
  />

        </Routes>


      </div>
    </Router>
  );
}

export default App;
